angular.module('app.directives').directive('match', () =>
    ({
        require: 'ngModel',
        restrict: 'A',
        scope: {
            match: '='
        },
        link(scope, elem, attrs, ctrl) {
            const expression = function() {
                /* This original implementation assumes ngRequired-like semantics
                   in addition to matching.  Let's simplify to just matching...
                const v = ctrl.$modelValue || ctrl.$$invalidModelValue;
                if (ctrl.$pristine) {
                    return angular.isUndefined(v);
                } else {
                    return scope.match === v;
                }
                */
                return scope.match == ctrl.$modelValue;
            };

            const listener = v => ctrl.$setValidity('match', v);

            return scope.$watch(expression, listener);
        }
    }));


// WEBPACK FOOTER //
// ./directives/match.js